import React from 'react';
import style from './Footer.module.css';

function Footer() {
    return (
        <div className={style.footerContainer}>
            <p>&copy;All rights reserved | Design by Noman Ishaq</p>
        </div>
    )
}

export default Footer
